import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var SignalHttpService = /** @class */ (function () {
    function SignalHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    SignalHttpService.prototype.getSignalStrength = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-signal-strength/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    SignalHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SignalHttpService_Factory() { return new SignalHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: SignalHttpService, providedIn: "root" });
    return SignalHttpService;
}());
export { SignalHttpService };
